import { create } from "zustand"
import { IntakeDate, IntakeLocation } from "toptaal-shared"

interface IntakeState {
  selectedLocationId: number | undefined
  selectedLocation: IntakeLocation | null
  selectedIntakeId: number | undefined
  selectedDate: IntakeDate | null
  currentStep: 1 | 2

  setSelectedLocationId: (locationId: number) => void
  setSelectedLocation: (location: IntakeLocation | null) => void
  setSelectedIntakeId: (intakeId: number) => void
  setSelectedDate: (date: IntakeDate) => void
  setCurrentStep: (step: 1 | 2) => void
  clearIntake: () => void
}

export const useIntakeStore = create<IntakeState>((set) => ({
  selectedLocationId: undefined,
  selectedLocation: null,
  selectedIntakeId: undefined,
  selectedDate: null,
  currentStep: 1,

  setSelectedLocationId: (locationId) =>
    set({ selectedLocationId: locationId }),

  setSelectedLocation: (location) =>
    set({ selectedLocation: location, selectedLocationId: location?.id }),

  setSelectedIntakeId: (intakeId) => set({ selectedIntakeId: intakeId }),

  setSelectedDate: (date) => set({ selectedDate: date }),

  setCurrentStep: (step) => set({ currentStep: step }),

  clearIntake: () =>
    set({
      selectedLocationId: undefined,
      selectedLocation: null,
      selectedIntakeId: undefined,
      selectedDate: null,
      currentStep: 1,
    }),
}))
